var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tabs',{attrs:{"active-index":_vm.selected,"size":"normal","scrollable":_vm.scrollable},on:{"click-tab":_vm.onSelect}},_vm._l((_vm.listDatas),function(item,index){return _c('Tab',{key:index,attrs:{"name":index,"title":item.label}})}))}
var staticRenderFns = []

export { render, staticRenderFns }